import api from '../../../services/api';

const API_URL = '/api/v1/employee/bidProfile';

/**
 * @returns {Promise<ApiEmployee.GetAllBidProfilesResponse>}
 */
export const getAllBidProfiles = () => api.get(API_URL);

/**
 * @returns {Promise<ApiEmployee.GetAllBidProfilesResponse>}
 */
export const getAllArchivedBidProfiles = () => api.get(`${API_URL}/Archive`);

/**
 * @param {string} profileId
 * @returns {Promise<ApiEmployee.GetBidProfileResponse>}
 */
export const getBidProfile = (profileId) => api.get(`${API_URL}/${profileId}`);

/**
 * @param {string} profileId
 * @returns {Promise<ApiEmployee.GetBidProfileResponse>}
 */
export const getBidProfileSummary = (profileId) => api.get(`${API_URL}/${profileId}/summary`);

/**
 * @param {string} profileId
 * @param {EmployeeBidSelectionDraft.IEmployeePreferentialBidSelectionDraft} bidSelection
 * @returns {Promise<ApiEmployee.GetBidProfileResponse>}
 */
export const saveBidSelectionDraft = (profileId, bidSelection) => api.post(`${API_URL}/${profileId}/bid/submit/draft`, bidSelection);

/**
 * @param {string} profileId
 * @param {EmployeeBidSelection.IEmployeePreferentialBidSelection} bidSelection
 * @returns {Promise<ApiEmployee.GetBidProfileResponse>}
 */
export const saveBidSelection = (profileId, bidSelection) => api.post(`${API_URL}/${profileId}/bid/submit`, bidSelection);

/**
 * @param {string} profileId
 * @returns {Promise<ApiEmployee.GetBidProfileResponse>}
 */
export const declineBidSelection = (profileId) => api.post(`${API_URL}/${profileId}/bid/decline`);

/**
 * @param {string} profileId
 * @returns {Promise<ApiEmployee.GetBidProfileResponse>}
 */
export const lockAwardedShiftline = (profileId) => api.post(`${API_URL}/${profileId}/awardedShiftline/lock`);

/**
 * @param {string} profileId
 * @returns {Promise<ApiEmployee.GetBidProfileResponse>}
 */
export const unlockAwardedShiftline = (profileId) => api.post(`${API_URL}/${profileId}/awardedShiftline/unlock`);
